module.exports = __webpack_public_path__ + "static/media/array-mobile.598aab61.png";